const wp_api = "wp_api_auth_tkon/wp-json/wp/v2";
const wp_api_auth = "https://api.testingdev.ga";
const farmageo_api = process.env.REACT_APP_FARMAGEO_API;
//const farmageo_api = "http://localhost:3110";
const image_path_server = process.env.REACT_APP_FARMAGEO_BUCKET;
const google_api = process.env.REACT_APP_GOOGLE_API
//const image_path_server = "https://testing-farmageo.s3.amazonaws.com/";
export { wp_api, farmageo_api, wp_api_auth, image_path_server, google_api };
